import { render } from "./FileListControl.vue?vue&type=template&id=3f98613a"
import script from "./FileListControl.vue?vue&type=script&lang=ts"
export * from "./FileListControl.vue?vue&type=script&lang=ts"
script.render = render

export default script